<template>
  <input-template
    :error="error"
    :disabled="disabled"
    :filled="isFilled"
    :focused="isFocused"
    @click.self="handleFocus"
  >
    <label slot="label" :for="getId">
      {{ label }}
    </label>
    <base-input
      :id="getId"
      :ref="`base-input-${getId}`"
      :type="type"
      :value="value"
      :inputmode="inputmode"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      :readonly="readonly"
      :force-replace="forceReplace"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </input-template>
</template>

<script>
import { generateRandomString } from 'lib/utils/string';

import BaseInput from 'atoms/base/BaseInput';
import InputTemplate from 'templates/InputTemplate';

export default {
  name: 'LabeledInput',
  components: {
    BaseInput,
    InputTemplate,
  },
  props: {
    value: String,
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
    error: Boolean,
    forceReplace: {
      type: Array,
      default: () => [],
    },
    inputmode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  computed: {
    getId() {
      return generateRandomString();
    },
    isFilled() {
      return this.$validate.isNotEmptyString(this.value);
    },
  },
  watch: {
    autofocus: {
      immediate: true,
      async handler(val) {
        await this.$nextTick;
        this.isFocused = val;
      },
    },
    isFocused: {
      immediate: true,
      handler(val) {
        if (val) {
          this.setFocus();
        }
      },
    },
  },
  methods: {
    setFocus() {
      this.$refs[`base-input-${this.getId}`].$el.focus();
    },
    handleInput(value) {
      this.$emit('input', value);
    },
    handleFocus() {
      if (this.isFocused) {
        return;
      }

      this.isFocused = true;
      this.$emit('focus');
    },
    handleBlur() {
      this.isFocused = false;
      this.$emit('blur');
    },
  },
};
</script>
